/* generated by build_shopify.py — do not edit */
window.SW_CATALOGUE = {
 "config": {
  "siteUrl": "https://swskinn.com",
  "shopUrl": "",
  "whatsappNumber": "917289835124",
  "productsEndpoint": "",
  "handoffEndpoint": "https://api.swskinn.com/api/handoff",
  "analyseEndpoint": "https://api.swskinn.com/api/analyse",
  "consentVersion": "wa-consent-2026-09",
  "apiBase": "https://api.swskinn.com",
  "nativeCart": true
 },
 "products": {
  "primask": {
   "name": "Primask",
   "fullName": "SW Primask",
   "dimension": "ACNE",
   "dimensionLabel": "Clarity & Control",
   "descriptor": "Triple-act clarifying zinc oxide mask",
   "short": "Zinc oxide with bentonite and kaolin clays to help absorb excess oil, clear pore congestion and refine skin texture.",
   "ingredients": [
    "Zinc oxide",
    "Bentonite",
    "Kaolin"
   ],
   "size": "48 ml",
   "suits": "Oily, combination and breakout-prone skin",
   "path": "/products/swskinn-primask",
   "shopifyHandle": "swskinn-primask",
   "shopifyProductId": 8500572586141,
   "image": "https://cdn.shopify.com/s/files/1/0691/9808/6301/files/041F7342-7BC1-4C3F-8C3B-41EF2829B115.jpg",
   "packMolecules": [
    "ZnO (zinc oxide)",
    "Bentonite",
    "Kaolin"
   ],
   "ingredientLine": "Bentonite and kaolin clays, enriched with ZnO (zinc oxide)"
  },
  "restore": {
   "name": "Restore",
   "fullName": "SW Restore Gel",
   "dimension": "BARRIER",
   "dimensionLabel": "Repair & Resilience",
   "descriptor": "Oil-free barrier repair gel moisturiser",
   "short": "A lightweight, oil-free gel that hydrates, soothes and supports the skin barrier, including after dermatology procedures.",
   "ingredients": [
    "Aloe barbadensis",
    "Vitamin C",
    "Vitamin E",
    "Botanical extracts"
   ],
   "size": "30 ml",
   "suits": "All skin types, including oily and breakout-prone",
   "path": "/products/swskinn-restore-gel-gentle-oil-free-moisturizer-hydrating-lightweight-non-greasy-gel-for-all-skin-types",
   "shopifyHandle": "swskinn-restore-gel-gentle-oil-free-moisturizer-hydrating-lightweight-non-greasy-gel-for-all-skin-types",
   "shopifyProductId": 8707047620765,
   "image": "https://cdn.shopify.com/s/files/1/0691/9808/6301/files/restore.jpg",
   "howToUse": "Apply 2\u20133 pumps to clean skin and gently pat until absorbed. Use morning and evening; follow with sunscreen during the day.",
   "packMolecules": [
    "Phenol alprogen",
    "Amino acids",
    "Rich phyto extracts"
   ],
   "ingredientLine": "Phenol alprogen, Amino acids, Vitamin C enriched phyto-extracts based scientific formulation"
  },
  "vitality": {
   "name": "Vitality",
   "fullName": "SW Vitality",
   "dimension": "VITALITY",
   "dimensionLabel": "Radiance & Age Wellbeing",
   "descriptor": "Antioxidant vitamin combination",
   "short": "Niacinamide, retinol, vitamin C and vitamin E in one formula to support radiance, a more even-looking tone, firmness and hydration.",
   "ingredients": [
    "Niacinamide (vitamin B3)",
    "Retinol",
    "Vitamin C",
    "Tocopherol (vitamin E)"
   ],
   "size": "30 ml",
   "suits": "Dullness, uneven-looking tone, early visible ageing",
   "path": "/products/sw-vitality",
   "shopifyHandle": "sw-vitality",
   "shopifyProductId": 8707057746077,
   "image": "https://cdn.shopify.com/s/files/1/0691/9808/6301/files/vitality.jpg",
   "containsRetinoid": true,
   "packMolecules": [
    "Niacin",
    "Retinol",
    "Vitamin C",
    "Tocopherol"
   ],
   "ingredientLine": "Antioxidant-rich phyto-extract formulation, enriched with niacin, retinol, vitamin C and tocopherol"
  }
 },
 "routines": {
  "advanced-anti-acne-system": {
   "name": "Advanced Anti-Acne System",
   "products": [
    "primask",
    "restore"
   ],
   "priorities": [
    "ACNE",
    "BARRIER"
   ],
   "summary": "Clarify, then calm. Primask helps control oil and congestion; Restore keeps the barrier comfortable while you do."
  },
  "vitality-barrier": {
   "name": "Vitality + Barrier Routine",
   "products": [
    "vitality",
    "restore"
   ],
   "priorities": [
    "VITALITY",
    "BARRIER"
   ],
   "summary": "Radiance built on a resilient base. Vitality brings the actives; Restore makes them easier to live with."
  },
  "complete-skin-routine": {
   "name": "Complete Skin Routine",
   "products": [
    "primask",
    "restore",
    "vitality"
   ],
   "priorities": [
    "ACNE",
    "BARRIER",
    "VITALITY"
   ],
   "summary": "For skin asking for attention on all three dimensions at once: clarity, resilience and radiance."
  },
  "age-well": {
   "name": "Age Well Routine",
   "products": [
    "primask",
    "restore",
    "vitality"
   ],
   "priorities": [
    "VITALITY",
    "BARRIER",
    "ACNE"
   ],
   "summary": "A considered routine for skin in its thirties, forties and beyond: refine, restore, revitalise."
  }
 }
};
